export default "__VITE_ASSET__BPt83FLf__"